import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import Tooltip from 'components/ui/Tooltip';

import routes from 'app/routes';
import editIcon from 'images/icons/invite/edit.svg';
import deleteIcon from 'images/icons/invite/delete.svg';
import impersonateIcon from 'images/icons/invite/impersonate.svg';
import inviteIcon from 'images/icons/invite/invitation.svg';

import { useContext } from '../Context';
import ApproveTrainingAction from './ApproveTrainingAction';

export default function Actions({ row, inviteAffiliate }) {
  const { dispatch, actions } = useContext();

  const deleteAffiliate = (e) => {
    swal(
      {
        title: '',
        text: 'Do you want to delete this affiliate user?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        closeOnConfirm: true,
        closeOnCancel: true,
      },
      (isConfirm) => {
        if (isConfirm) {
          let el = e.target;
          while (el && el.tagName !== 'BUTTON') {
            el = el.parentNode;
          }

          el.innerHTML = '<i class="fa fa-spinner fa-spin" style="width: 26px"></i>';
          actions.delete(dispatch, row.id);
        }
      },
    );
  };

  const requestedTraining = row.attributes.training_requested_at && !row.attributes.training_approved_at;

  return (
    <div>
      {requestedTraining && <ApproveTrainingAction affiliateId={row.id} />}

      <a
        target="_blank"
        href={routes.api.users.impersonate(row.attributes.user_id)}
        className="btn btn-link pl0 pr0 mr5"
        data-tip="Impersonate"
        rel="noreferrer"
      >
        <img src={impersonateIcon} alt="impersonate" />
      </a>

      <a
        target="_blank"
        href={routes.admin.affiliates.edit(row.id)}
        className="btn btn-link pl0 pr0 mr5"
        data-tip="Edit"
        rel="noreferrer"
      >
        <img src={editIcon} alt="edit" />
      </a>

      <Button
        bsStyle="link"
        className="pl0 pr0 mr5"
        data-tip="Invite"
        onClick={() => inviteAffiliate(row)}
      >
        <img src={inviteIcon} alt="invite" />
      </Button>

      <Button
        bsStyle="link"
        className="pl0 pr0"
        onClick={(e) => deleteAffiliate(e)}
        data-tip="Delete"
      >
        <img src={deleteIcon} alt="delete" />
      </Button>

      <Tooltip />
    </div>
  );
}

Actions.propTypes = {
  row: PropTypes.object.isRequired,
};
